import { render, staticRenderFns } from "./candidateNote.vue?vue&type=template&id=149a4761&scoped=true"
import script from "./candidateNote.vue?vue&type=script&lang=js"
export * from "./candidateNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149a4761",
  null
  
)

export default component.exports